import { CtrlBaseComponent } from '../controls';

export class ViewModel {

    public ctType: string;
    public controlProperties: Object;
    public controlActions: Array<any>;
    public models: Array<CtrlBaseComponent>;

    constructor(obj: any = null) {
        if (obj)
            Object.assign(this, obj);
    }
}

export class TypedViewModel<T extends Object> {

    public ctType: string;
    public controlProperties: Object;
    public controlActions: Array<any>;
    public models: Array<CtrlBaseComponent>;


    constructor(obj: any = null) {
        if (obj)
            Object.assign(this, obj);
    }
}